import { DetailsRow, IDetailsFooterProps } from "@fluentui/react";
import { useEffect } from "react";
import { useTheme } from "react-jss";
import { fetchStatiticsIncidenceOperatorFilterAction } from "../../../../redux/actions/statistics/statistics";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { heights } from "../../../../styles/romeu/heights";
import { CustomDetailsList } from "../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../common/skeleton/skeleton";
import { StatisticsIncidenceOrganismListColumn } from "./column/column";
import { StatisticsIncidenceOperatorListColumnFooter } from "./column/footer";
import { StatisticsIncidenceOperatorListStyle } from "./listStyle.jss";
import { SkeletonSizes } from "../../../../common/constants";

export const StatisticsIncidenceOperatorList = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const style = StatisticsIncidenceOperatorListStyle({ theme });
    const { operatorStatistics, loading } = useAppSelector((state) => state.statisticsOperatorIncidenceList.data);

    const onRenderColumns = () => {
        return StatisticsIncidenceOrganismListColumn();
    };
    const _onRenderDetailsFooter = (detailsFooterProps: IDetailsFooterProps) => {
        const dataFooter = {
            listColumnsFooter: detailsFooterProps.columns,
        };
        const footerColumns = StatisticsIncidenceOperatorListColumnFooter(dataFooter);

        return (
            <DetailsRow
                {...detailsFooterProps}
                columns={footerColumns}
                item={{}}
                itemIndex={5}
                groupNestingDepth={detailsFooterProps.groupNestingDepth}
                selection={detailsFooterProps.selection}
                styles={style}
            />
        );
    };
    useEffect(() => {
        !loading && dispatch(fetchStatiticsIncidenceOperatorFilterAction());
    }, []);

    return !loading ? (
        <CustomDetailsList
            data={operatorStatistics}
            renderColumns={onRenderColumns}
            height={heights.statistics.incidence}
            customFooter={_onRenderDetailsFooter}
        />
    ) : (
                        <Skeleton rows={SkeletonSizes.DEFAULT} />

    );
};
